import React from 'react';

/**
 * A top-level context provider to expose CountryCodes from redux-state.
 * @type {ReactContext}
 */
export default React.createContext({});
